<dx-load-panel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoader" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false" [message]="messageLoader" height="10%" width="15%"></dx-load-panel>
<div class="row animated fadeIn">
    <div class="col-sm-12">
        <!-- meta -->
        <div class="profile-user-box user-box bg-custom">
            <div class="row">
                <div class="col-sm-6">
                    <span class="pull-left mr-3"><img src="./assets/global/images/users/avatar-2.jpg" alt="" class="thumb-sm rounded-circle"></span>
                    <div class="media-body">
                        <h5 class="mt-1 mb-1 font-15">{{userSesion.name}} {{userSesion.lastName}} {{userSesion.sourName}}</h5>
                        <p class="card-subtitle text-muted">{{valueCompanyName()}}</p>
                    </div>
                </div>
                <div class="col-sm-6" *ngIf="configuracion">
                    <div class="text-right">
                        <button type="button" class="btn btn-light waves-effect">
              <i class="mdi mdi-account-settings-variant mr-1"></i> Actualizar Usuarios y Empresas
            </button>
                    </div>
                </div>
                <div class="col-sm-6" *ngIf="home">
                    <form [formGroup]="formBissness" autocomplete="off">
                        <ng-select2 id="ddlBissness" [allowClear]="true" formControlName="ddlBissness" *ngIf="listBissness.length > 0" [data]="listBissness" class="form-control custom-select mt-3" (valueChanged)="onChange($event)"></ng-select2>
                        <input *ngIf="listBissness.length == 0" type="text" [value]="'PACs.creacionPrograma.CargandoInformacion' | translate" class="form-control" readonly />
                    </form>
                </div>
            </div>
        </div>
        <!--/ meta -->
    </div>
</div>